const getFileHash = async file => {
  const arrayBuffer = await file.arrayBuffer();

  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);

  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export default getFileHash;
